import { AuthService } from './authentication/auth.service';
import { ViewControllerService } from './view/ViewControllerService';

export function viewControllerService() {
  return (_authenticationService: AuthService): ViewControllerService => {
    return new ViewControllerService(_authenticationService);
  };
}